(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pn-all-cards-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__pnSmoothCardFiltersBound) return;
    window.__pnSmoothCardFiltersBound = true;

    const closeDrawer = (root, restoreFocus = false) => {
      if (!(root instanceof HTMLElement)) return;

      const layer = root.querySelector('[data-pn-filter-layer]');
      const openButton = root.querySelector('[data-pn-filter-open]');

      layer?.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-open');
      document.documentElement.classList.remove('pn-filter-lock');
      document.body.classList.remove('pn-filter-lock');
      openButton?.setAttribute('aria-expanded', 'false');

      if (restoreFocus && openButton instanceof HTMLElement) {
        openButton.focus();
      }
    };

    const openDrawer = (root) => {
      if (!(root instanceof HTMLElement)) return;

      const layer = root.querySelector('[data-pn-filter-layer]');
      const drawer = root.querySelector('[data-pn-filter-drawer]');
      const openButton = root.querySelector('[data-pn-filter-open]');

      layer?.setAttribute('aria-hidden', 'false');
      root.classList.add('is-open');
      document.documentElement.classList.add('pn-filter-lock');
      document.body.classList.add('pn-filter-lock');
      openButton?.setAttribute('aria-expanded', 'true');

      window.requestAnimationFrame(() => drawer?.focus());
    };

    const parseNumber = (value) => {
      if (typeof value !== 'string') return Number(value) || 0;

      const normalized = value
        .trim()
        .replace(/\s/g, '')
        .replace(/\.(?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.')
        .replace(/[^\d.-]/g, '');

      return Number(normalized) || 0;
    };

    const updatePriceRange = (priceRange, changedElement) => {
      if (!(priceRange instanceof HTMLElement)) return;

      const rangeMin = priceRange.querySelector('[data-pn-range-min]');
      const rangeMax = priceRange.querySelector('[data-pn-range-max]');
      const numberMin = priceRange.querySelector('[data-pn-price-min]');
      const numberMax = priceRange.querySelector('[data-pn-price-max]');
      const fill = priceRange.querySelector('[data-pn-price-fill]');
      const absoluteMax = Number(priceRange.dataset.rangeMax || 0);

      if (
        !(rangeMin instanceof HTMLInputElement) ||
        !(rangeMax instanceof HTMLInputElement) ||
        !(numberMin instanceof HTMLInputElement) ||
        !(numberMax instanceof HTMLInputElement) ||
        !(fill instanceof HTMLElement) ||
        absoluteMax <= 0
      ) {
        return;
      }

      const clamp = (value) => Math.min(Math.max(parseNumber(String(value)), 0), absoluteMax);

      let minValue =
        changedElement === numberMin || changedElement === numberMax
          ? (numberMin.value === '' ? 0 : clamp(numberMin.value))
          : clamp(rangeMin.value);

      let maxValue =
        changedElement === numberMin || changedElement === numberMax
          ? (numberMax.value === '' ? absoluteMax : clamp(numberMax.value))
          : clamp(rangeMax.value);

      if (minValue > maxValue) {
        if (changedElement === rangeMax || changedElement === numberMax) {
          minValue = maxValue;
        } else {
          maxValue = minValue;
        }
      }

      rangeMin.value = String(minValue);
      rangeMax.value = String(maxValue);

      if (changedElement === rangeMin || changedElement === rangeMax) {
        numberMin.value = String(Math.round(minValue));
        numberMax.value = String(Math.round(maxValue));
      }

      const minPercent = (minValue / absoluteMax) * 100;
      const maxPercent = (maxValue / absoluteMax) * 100;

      fill.style.left = `${minPercent}%`;
      fill.style.right = `${100 - maxPercent}%`;
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const openButton = event.target.closest('[data-pn-filter-open]');

      if (openButton) {
        openDrawer(openButton.closest('[data-pn-card-filters]'));
        return;
      }

      const closeButton = event.target.closest('[data-pn-filter-close]');

      if (closeButton) {
        closeDrawer(closeButton.closest('[data-pn-card-filters]'), true);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-pn-card-filters].is-open').forEach((root) => {
        closeDrawer(root, true);
      });
    });

    document.addEventListener('input', (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;

      if (event.target.matches('[data-pn-global-filter-search]')) {
        const query = event.target.value.trim().toLocaleLowerCase('nb-NO');
        const form = event.target.closest('form');

        form?.querySelectorAll('[data-pn-filter-group]').forEach((group) => {
          const groupLabel = group.dataset.pnFilterLabel || '';
          const options = group.querySelectorAll('[data-pn-filter-option]');
          let hasMatchingOption = false;

          options.forEach((option) => {
            const optionLabel = option.dataset.pnFilterOption || '';
            const optionMatches =
              query === '' ||
              optionLabel.includes(query) ||
              groupLabel.includes(query);

            option.hidden = !optionMatches;

            if (optionMatches) {
              hasMatchingOption = true;
            }
          });

          const groupMatches =
            query === '' ||
            groupLabel.includes(query) ||
            hasMatchingOption;

          group.hidden = !groupMatches;

          if (query !== '' && groupMatches && group instanceof HTMLDetailsElement) {
            group.open = true;
          }
        });

        return;
      }

      if (event.target.matches('[data-pn-filter-search]')) {
        const query = event.target.value.trim().toLocaleLowerCase('nb-NO');
        const groupContent = event.target.closest('.pn-card-filters__group-content');

        groupContent?.querySelectorAll('[data-pn-filter-option]').forEach((option) => {
          const label = option.dataset.pnFilterOption || '';
          option.hidden = query !== '' && !label.includes(query);
        });

        return;
      }

      if (
        event.target.matches(
          '[data-pn-range-min], [data-pn-range-max], [data-pn-price-min], [data-pn-price-max]'
        )
      ) {
        updatePriceRange(event.target.closest('[data-pn-price-range]'), event.target);
      }
    });

    /*
      På mobil lukkes vår egendefinerte skuff idet et filter endres.
      facets.js renderer deretter kun collection-seksjonen på nytt.
    */
    document.addEventListener(
      'change',
      (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;

        if (
          !event.target.matches(
            '.pn-card-filters__checkbox-input, [data-pn-range-min], [data-pn-range-max], [data-pn-price-min], [data-pn-price-max]'
          )
        ) {
          return;
        }

        const root = event.target.closest('[data-pn-card-filters]');

        if (root?.classList.contains('is-open')) {
          closeDrawer(root, false);
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
